<template>
  <div>
    <p class="text-white">
      Zoek de plaats die je graag wil zien:
    </p>
    <form v-on:submit.prevent="search" class="flex flex-row gap-2">
      <input ref="autocomplete"
             placeholder="Amsterdam, Nederland"
             class="flex-1 w-full"
             onfocus="placeholder = ''"
             type="search"/>
      <button type="submit" class="px-2 py-2 mt-1 mb-3 bg-yellow-200 hover:bg-yellow-300 text-yellow-700 w-10 flex items-center justify-center">
        <svg  class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </button>
    </form>

    <!--    <div style="font-size: 80%; color: white; margin: -15px 0 15px 0">-->
    <!--      {{ location.city }}, {{ location.country }} : {{ location.dms.lat }}, {{ location.dms.lng }}-->
    <!--    </div>-->
  </div>
</template>

<script>
export default {
  name: "LocationAutoComplete",

  data() {
    return {
      location: {
        city: 'Amsterdam',
        country: 'Nederland',
        dms: 'N 52º22\'01" E 04º53\'40"'
      }
    }
  },

  mounted() {
    // try {
    //   this.autocomplete = new google.maps.places.Autocomplete(
    //       (this.$refs.autocomplete),
    //       {types: []}
    //   );
    //
    //   this.autocomplete.addListener('place_changed', () => {
    //     let place = this.autocomplete.getPlace();
    //
    //     if (!place.geometry) {
    //       // find the old fasioned way
    //       // const query = this.$refs.autocomplete.value;
    //       // this.$root.search(query)
    //
    //       return;
    //     }
    //
    //     console.log('place', place);
    //
    //     let address_components = place.address_components;
    //     let lat = place.geometry.location.lat();
    //     let lng = place.geometry.location.lng();
    //     // let city = ac[0]["short_name"];
    //     // let country = ac[ac.length - 1]["long_name"];
    //
    //     // TODO what if not exists
    //     let city_component = address_components.filter(component =>
    //         component.types.includes('locality'),
    //     );
    //
    //     if (city_component.length === 0) {
    //       city_component = address_components.filter(component =>
    //           component.types.includes('administrative_area_level_1'),
    //       );
    //     }
    //     if (city_component.length === 0) {
    //       city_component = address_components;
    //     }
    //
    //     let country_component = address_components.filter(component =>
    //         component.types.includes('country'),
    //     );
    //
    //     const city = city_component[0].long_name;
    //     const country = country_component[0].long_name;
    //
    //     this.$root.trackSearch(city);
    //
    //     const bounds = [
    //       [
    //         place.geometry.viewport.getSouthWest().lat(),
    //         place.geometry.viewport.getSouthWest().lng()
    //       ], [
    //         place.geometry.viewport.getNorthEast().lat(),
    //         place.geometry.viewport.getNorthEast().lng(),
    //       ]
    //     ];
    //
    //     this.location = {
    //       'dms': ddToDms(lat, lng),
    //       lat,
    //       lng,
    //       city,
    //       country,
    //       bounds
    //     };
    //
    //     this.$emit('update-location', this.location)
    //
    //     console.log(`The user picked ${city} with the coordinates ${lat}, ${lng}`);
    //   });
    // } catch {
    // }
  },
  methods: {
    search() {
      const query = this.$refs.autocomplete.value;
      this.$root.search(query)
    }
  }
}
</script>

<style scoped>
</style>
